const valhallaPolylineDecode = (encoded, precision = 6) => {
  if (!encoded) {
    return [];
  }

  let index = 0;
  let lat = 0;
  let lng = 0;

  const coordinates = [];
  const factor = Math.pow(10, precision);

  while (index < encoded.length) {
    let byte;
    let shift = 0;
    let result = 0;

    // Latitude
    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const latitudeChange =
      result & 1
        ? ~(result >> 1)
        : result >> 1;

    lat += latitudeChange;

    // Longitude
    shift = 0;
    result = 0;

    do {
      byte = encoded.charCodeAt(index++) - 63;
      result |= (byte & 0x1f) << shift;
      shift += 5;
    } while (byte >= 0x20);

    const longitudeChange =
      result & 1
        ? ~(result >> 1)
        : result >> 1;

    lng += longitudeChange;

    // GeoJSON / MapLibre expects [lng, lat]
    coordinates.push([
      lng / factor,
      lat / factor,
    ]);
  }

  return coordinates;
};

export default valhallaPolylineDecode;